/**
 * Claim mode (fnd-3uws). Stripe is not connected yet, so an owner who is ready
 * to buy is sent to a text or an email for an invoice instead of Stripe
 * Checkout. Default is OFF (contact mode). Set `VITE_ONLINE_CHECKOUT=true` at
 * build time to bring back the online path; the Stripe code (ClaimWizard's
 * payment step, the checkout-session call in InvitePage) is kept intact.
 */

export const ONLINE_CHECKOUT_ENABLED =
  import.meta.env.VITE_ONLINE_CHECKOUT === 'true';

/** The number the owner got the outreach text from; the sender signs "Mike". */
export const CONTACT_PHONE_DISPLAY = '(206) 227-6374';
export const CONTACT_PHONE_E164 = '+12062276374';
export const CONTACT_EMAIL = 'hello@foundlio.com';

export interface InvoiceRequest {
  businessName: string;
  /** Live preview URL, or `https://<slug>.foundlio.com`. May be empty. */
  siteUrl?: string;
  planName: string;
  monthly: number;
}

/** `sms:` link that opens Messages with the invoice request prefilled. */
export function invoiceSmsHref({ businessName, siteUrl, planName, monthly }: InvoiceRequest): string {
  const site = siteUrl ? ` (${siteUrl})` : '';
  const body =
    `Hi Mike, I want to keep the website for ${businessName}${site}. ` +
    `${planName} plan, $${monthly}/mo. Can you send me an invoice?`;
  return `sms:${CONTACT_PHONE_E164}?&body=${encodeURIComponent(body)}`;
}

/** `mailto:` link with the invoice subject and a prefilled body. */
export function invoiceMailtoHref({ businessName, siteUrl, planName, monthly }: InvoiceRequest): string {
  const subject = `Invoice for ${businessName}`;
  const body = [
    'Hi Mike,',
    '',
    `Please send me an invoice to keep the website for ${businessName}.`,
    '',
    `Site: ${siteUrl || '(link not available)'}`,
    `Plan: ${planName}, $${monthly}/mo, $0 setup`,
  ].join('\n');
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
